import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { useWebsiteButton } from "../../customeHooks/useWebsiteButtons";
import { SingleFindEvent } from "../../redux/features/event/event.types";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { formatDate } from "../../utils/helpers";
import { EventPosterImage } from "./eventPosterImage";

export const TrendingEventCard = ({ event }: { event: SingleFindEvent }) => {
  const { goToEvent } = useWebsiteButton();

  return (
    <Link
      className="group flex w-[200px] shrink-0 flex-col gap-3"
      to={goToEvent(event?.slug!)}
    >
      <div className="relative size-[200px] shrink-0 overflow-hidden rounded-[6px]">
        <EventPosterImage
          className="absolute inset-0 h-full w-full object-cover transition-all duration-500 group-hover:scale-105"
          alt={`${event.name} event poster`}
          image={event.image}
        />
      </div>

      <div className="flex flex-col gap-[2px]">
        <p className="truncate font-onest text-base font-medium tracking-[-0.32px] text-ink">
          {event.name}
        </p>
        <p
          className="truncate font-onest text-[13px] text-[#7d7d7d]"
          style={{ fontFeatureSettings: '"ss01" 1' }}
        >
          {formatDate(event?.startDate, "ddd, MMM D", true)}
          {event?.startTime ? `, ${event.startTime}` : ""}
        </p>
      </div>
    </Link>
  );
};

export const TrendingCardLoader = () => {
  return (
    <div className="flex w-[200px] shrink-0 flex-col gap-3">
      <Skeleton
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
        baseColor={SKELETON_BASE_COLOR}
        width={200}
        height={200}
        className="!rounded-[6px]"
      />

      <div className="flex flex-col gap-[2px]">
        <Skeleton
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          baseColor={SKELETON_BASE_COLOR}
          width={"80%"}
          height={20}
          className="rounded-xl"
        />
        <Skeleton
          highlightColor={SKELETON_HIGHLIGHT_COLOR}
          baseColor={SKELETON_BASE_COLOR}
          width={"60%"}
          height={16}
          className="rounded-xl"
        />
      </div>
    </div>
  );
};
